import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

const PaymentSuccess = () => {
    const [searchParams] = useSearchParams();
    const [message, setMessage] = useState("Verifying your payment...");
    const [isSuccess, setIsSuccess] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const verifyPayment = async () => {
            const sessionId = searchParams.get("session_id");
            
            if (!sessionId) {
                setMessage("Invalid session ID");
                return;
            }

            try {
                // First check what type of session this is
                const sessionCheck = await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}/api/payment/check-session-type`,
                    { session_id: sessionId }
                );

                let response;
                if (sessionCheck.data.mode === 'payment') {
                    // This is a one-time payment for subject access
                    response = await axios.post(
                        `${process.env.REACT_APP_BACKEND_URL}/api/payment/verify-payment`,
                        { session_id: sessionId }
                    );
                } else if (sessionCheck.data.mode === 'subscription') {
                    // This is a subscription payment
                    response = await axios.post(
                        `${process.env.REACT_APP_BACKEND_URL}/api/payment/verify-subscription`,
                        { session_id: sessionId }
                    );
                } else {
                    throw new Error("Unknown payment type");
                }

                if (response.data.success) {
                    setMessage(response.data.message || 
                        (sessionCheck.data.mode === 'payment' 
                            ? `Payment successful! ${response.data.subject ? `You now have access to ${response.data.subject}.` : 'Your payment was successful.'}` 
                            : "Subscription payment successful! You now have access to all test types.")
                    );
                    setIsSuccess(true);
                    setTimeout(() => navigate("/new-student-dashboard"), 3000);
                } else {
                    setMessage(response.data.error || "Payment verification failed");
                }
            } catch (error) {
                setMessage(error.response?.data?.error || error.message || "Error verifying payment");
                console.error("Payment verification error:", error);
            }
        };

        verifyPayment();
    }, [searchParams, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
            <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
                <h2 className="text-2xl font-bold mb-4 text-center">
                    {isSuccess ? "Payment Successful!" : "Payment Verification"}
                </h2>
                <div className={`p-4 rounded-md ${isSuccess ? "bg-green-100 text-green-800" : "bg-blue-100 text-blue-800"}`}>
                    {message}
                </div>
                {isSuccess && (
                    <button
                        onClick={() => navigate("/new-student-dashboard")}
                        className="mt-4 w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700"
                    >
                        Go to Dashboard
                    </button>
                )}
            </div>
        </div>
    );
};

export default PaymentSuccess;